import {CaptchaProps} from './CaptchaTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractCaptchaPropsFromResponse(responseBody: Record<string, any>): CaptchaProps {
  return {
    captchaService: responseBody['captcha_service'],
    sitekey: responseBody['captcha_sitekey'],
    options: {
      rqdata: responseBody['captcha_rqdata'],
      rqtoken: responseBody['captcha_rqtoken'],
      serveInvisible: responseBody['should_serve_invisible'] ?? false,
      userflow: responseBody['user_flow'],
    },
  };
}
